import type { WindowDescriptor } from '@krp/client-runtime'

import type { OneCUiState } from '../../state'
import { uploadParamsChanged } from './model/importSlice'
import { EMPTY_UPLOAD_PARAMS, type UploadParams } from './model/types'

/** Окна импорта накладных 1С (UB1b). Каждый адрес содержит `:rid` (D-064). */
export const ONEC_IMPORT_WINDOWS = {
  wizard: 'onec.import',
  profiles: 'onec.import-profiles',
  file: 'onec.import-file',
} as const

function decodeUploadParams(raw: unknown): UploadParams | undefined {
  if (typeof raw !== 'object' || raw === null) return undefined
  const value = raw as Partial<Record<keyof UploadParams, unknown>>
  const read = (field: keyof UploadParams) => (typeof value[field] === 'string' ? value[field].slice(0, 200) : undefined)
  const sheet = read('sheet')
  const headerRow = read('headerRow')
  const profileId = read('profileId')
  const supplier = read('supplier')
  if (sheet === undefined || headerRow === undefined || profileId === undefined || supplier === undefined) return undefined
  return { sheet, headerRow, profileId, supplier }
}

export const importWindows: readonly WindowDescriptor<OneCUiState>[] = [
  {
    kind: ONEC_IMPORT_WINDOWS.wizard,
    scope: 'resource',
    paths: ['/resources/:rid/import'],
    label: 'Импорт накладной',
    size: 'lg',
    // Вкладка помнит параметры загрузки (лист, шапка, профиль), а не файл и не ответы 1С.
    capture: (state, params) => ({ ...(state.importFlow.uploadParams[params.rid ?? ''] ?? EMPTY_UPLOAD_PARAMS) }),
    restore: (snapshot, params) => {
      const decoded = decodeUploadParams(snapshot)
      return decoded === undefined || params.rid === undefined
        ? []
        : [uploadParamsChanged({ resourceId: params.rid, patch: decoded })]
    },
  },
  {
    kind: ONEC_IMPORT_WINDOWS.profiles,
    scope: 'resource',
    paths: ['/resources/:rid/import/profiles'],
    label: 'Профили колонок импорта',
    size: 'lg',
  },
  {
    kind: ONEC_IMPORT_WINDOWS.file,
    scope: 'resource',
    paths: ['/resources/:rid/import/files/:fileId'],
    label: 'Файл накладной',
    size: 'lg',
  },
]
